import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface GetOverviewAppointmentRequest extends HttpRequestData {
    readonly startTime: string;
    readonly endTime: string;
    readonly branchId?: string;
}

export interface GetOverviewAppointmentResponseItem {
    currentAppointmentCount: number;
    pastAppointmentCount: number;
}

export const getOverviewAppointment = httpUtil.createHttpRequestMeta<
    GetOverviewAppointmentRequest,
    GetOverviewAppointmentResponseItem
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/appointments/overview',
    method: 'GET',
    authentication: 'bearer',
});